import React from 'react'
import Select from './Select'
import SelectItem from './SelectItem'

interface IProps {
  theme?: string
  className?: string
  label?: string
  name?: string
  error?: string
  value?: string
  clearable?: boolean
}

const SelectAge = ({
  theme = 'gray',
  className,
  ...props
}: IProps): React.ReactElement => {
  return (
    <Select
      placeholder='Выбери возраст'
      theme={theme}
      className={className}
      {...props}
    >
      <SelectItem value='10-14'>10-14 лет</SelectItem>
      <SelectItem value='15-17'>15-17 лет</SelectItem>
      <SelectItem value='18'>18 и старше</SelectItem>
    </Select>
  )
}

export default SelectAge
